<template>
  <v-list-tile-avatar>
    <v-icon class="btn-hover" v-if="$store.getters.musicPlayerModuleGetIsPlaying && music.title === itemTitle && musicPlayerType === $store.getters['musicPlayerModuleGetNowPlayListType'] && (music.rank === undefined || music.rank === itemIndex) && music.productId == itemProductId" large color="blue-grey lighten-2" @click="stopMusic">pause_circle_outline</v-icon>
    <v-icon class="btn-hover" v-else large color="primary" @click="setMusic(itemIndex)">play_circle_outline</v-icon>
  </v-list-tile-avatar>
</template>

<script>
export default {
  name: 'PlayBtn',
  props: ['itemIndex', 'itemTitle', 'itemArtist', 'itemSrc', 'itemLyrics', 'itemProductId', 'musicPlayerType', 'resultsCount'],
  data () {
    return {
      durationT: 0
    }
  },
  computed: {
    music () {
      return this.$store.getters['musicPlayerModuleGetNowPlayTuneData']
    }
  },
  methods: {
    setMusicByIndex (index, playListType) {
      this.$store.commit('musicPlayerModuleStartPlayList', [index, playListType])
      let shufflePlayList = this.$store.getters.musicPlayerModuleGetNowSelectedPlayList
      let target = shufflePlayList.map(record => { return record })
      let a = target.length
      while (a) {
        let j = Math.floor(Math.random() * a)
        let t = target[--a]
        target[a] = target[j]
        target[j] = t
      }
      this.$store.commit('musicPlayerModuleUpdateShufflePlayList', target)
      this.$store.commit('musicPlayerModuleShuffle', this.$store.getters.musicPlayerModuleGetIsShufflePlay)
    },
    /**
     * 再生ボタンクリックした際に、プレーヤーに楽曲をセットする処理
     **/
    setMusic: function (itemIndex) {
      if (this.musicPlayerType) {
        if (this.musicPlayerType === 'searchShufflePlay') {
          this.musicPlayerType = 'search'
        }
        this.setMusicByIndex(itemIndex, this.musicPlayerType)
      }
      let audio = document.querySelector('#audio')
      const audioPlay = function () {
        audio.play()
      }
      setTimeout(audioPlay, 10)
      this.$store.commit('musicPlayerModuleUpdateIsPlaying', true)
    },
    stopMusic: function () {
      let audio = document.querySelector('#audio')
      setTimeout(audio.pause(), 10)
      this.$store.commit('musicPlayerModuleUpdateIsPlaying', false)
    },
    getDuration (e) {
      let audio = document.querySelector('#audio')
      this.music.durationTime = audio.duration
    }
  },
  mounted () {
    let audio = document.querySelector('#audio')
    audio.addEventListener('timeupdate', this.getDuration)
  }
}
</script>

<style lang="scss" scoped>
.btn-hover {
  cursor: pointer;
  &:hover {
    opacity: .8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlayBtn.vue